/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Templates_Edit_Is_DefaultInputs */

const en_forms_templates_edit_is_default = /** @type {(inputs: Forms_Templates_Edit_Is_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Default`)
};

const de_forms_templates_edit_is_default = /** @type {(inputs: Forms_Templates_Edit_Is_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Standard`)
};

/**
* | output |
* | --- |
* | "Is Default" |
*
* @param {Forms_Templates_Edit_Is_DefaultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_templates_edit_is_default = /** @type {((inputs?: Forms_Templates_Edit_Is_DefaultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Templates_Edit_Is_DefaultInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_templates_edit_is_default(inputs)
	return de_forms_templates_edit_is_default(inputs)
});